var processObject = function processObject(obj, uiSchema, converter) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    result[key] = processEntry(obj[key], uiSchema && uiSchema[key], converter);
  });
  return result;
};
var processArray = function processArray(arr, uiSchema, converter) {
  var childSchema = uiSchema && uiSchema.items;
  return arr.map(function (value) {
    return processEntry(value, childSchema, converter);
  });
};
var processEntry = function processEntry(entry, uiSchema, converter) {
  if (entry) {
    if (Array.isArray(entry)) {
      return processArray(entry, uiSchema, converter);
    }
    if (typeof entry === 'object') {
      return processObject(entry, uiSchema, converter);
    }
    if (typeof entry === 'string') {
      if (uiSchema && uiSchema['ui:widget'] === 'richtext') {
        return converter(entry);
      }
    }
  }
  return entry;
};
var convertToFroala = function convertToFroala(value) {
  return value
  // Needs to be first
  .replace(/&/g, '&amp;')
  // Needs to be second
  .replace(/</g, '&lt;').replace(/>/g, '&gt;')
  // All the rest
  .replace(/"/g, '&quot;').replace(/'/g, '&apos;').replace(/&lt;b&gt;/gi, '<strong>').replace(/&lt;\/b&gt;/gi, '</strong>').replace(/&lt;strong&gt;/gi, '<strong>').replace(/&lt;\/strong&gt;/gi, '</strong>').replace(/&lt;i&gt;/gi, '<em>').replace(/&lt;\/i&gt;/gi, '</em>').replace(/&lt;em&gt;/gi, '<em>').replace(/&lt;\/em&gt;/gi, '</em>').replace(/&lt;sub&gt;/gi, '<sub>').replace(/&lt;\/sub&gt;/gi, '</sub>').replace(/&lt;sup&gt;/gi, '<sup>').replace(/&lt;\/sup&gt;/gi, '</sup>').replace(/&lt;u&gt;/gi, '<u>').replace(/&lt;\/u&gt;/gi, '</u>').replace(/&lt;br&gt;/gi, '<br>').replace(/\n/g, '<br>');
};
var convertFromFroala = function convertFromFroala(value) {
  return value.replace(/&#39;/g, "'").replace(/&apos;/gi, "'").replace(/&nbsp;/gi, ' ').replace(/&quot;/gi, '"').replace(/<\/em>/g, '</i>').replace(/<\/strong>/g, '</b>').replace(/<em>/g, '<i>').replace(/<strong>/g, '<b>')
  // Needs to be second last
  .replace(/&gt;/gi, '>').replace(/&lt;/gi, '<')
  // Needs to be last
  .replace(/&amp;/gi, '&');
};
function stripTags(html) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (html) {
    return html.replace(/<(\/?)(\w+)[^>]*\/?>/g, function (_, endMark, tag) {
      return args.includes(tag) ? '<' + endMark + tag + '>' : '';
    }).replace(/<!--.*?-->/g, '');
  }
  return '';
}
export function toFroala(data, uiSchema) {
  return processEntry(data, uiSchema, convertToFroala);
}
export function fromFroala(data, uiSchema) {
  return processEntry(data, uiSchema, convertFromFroala);
}
export default {
  toFroala: toFroala,
  fromFroala: fromFroala,
  stripTags: stripTags
};